import React from "react";
import { RoutePermittedRole } from "shared/constants/AppConst";
const NewsUpdates = React.lazy(() => import("./NewsUpdates"));
const NewsDetails = React.lazy(() => import("./NewsUpdates/NewsDetails"));

export const NewsUpdateConfigs = [
    {
        permittedRole: [
            // RoutePermittedRole.FRONTDESK,
            RoutePermittedRole.MANAGER,
            // RoutePermittedRole.LOCATION_MANAGER,
            RoutePermittedRole.ADMIN,
            RoutePermittedRole.SUPER_ADMIN,
            RoutePermittedRole.MEMBER,
            // RoutePermittedRole.HR_MANAGER,
            // RoutePermittedRole.FINANCE_MANAGER,
            // RoutePermittedRole.DOCTOR,
            // RoutePermittedRole.KITCHEN,
            // RoutePermittedRole.ACCOMODATION,
        ],
        path: "/news",
        element: <NewsUpdates />,
    },
    {
        permittedRole: [
            RoutePermittedRole.ADMIN,
            RoutePermittedRole.SUPER_ADMIN,
            RoutePermittedRole.MEMBER,
            RoutePermittedRole.MANAGER,
            RoutePermittedRole.LOCATION_MANAGER,
            RoutePermittedRole.HR_MANAGER,
            RoutePermittedRole.FINANCE_MANAGER,
            RoutePermittedRole.FRONTDESK,
            RoutePermittedRole.DOCTOR,
            RoutePermittedRole.ACCOMODATION,
            RoutePermittedRole.KITCHEN,
        ],
        path: "/news/:id",
        element: <NewsDetails />,
    },
];
